import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import Loader from '../../legacyCMS/components/Loader';
import MessagingBase from '../../legacyCMS/tvmesaging/MessagingBase';

export const LegacyMessaging = () => {
  const { logged } = useSelector(state => state.authReducer);
  const loadingReducer = useSelector(state => {
    return Object.entries(state)
      .filter(key => {
        if (key[1].loading)
          return key;
        return null
      });
  })

  return (
    <>
      {
        !logged ?
          <Redirect to={`/login/tvmessaging`} />
          :
          <>
            {/* LOADING SCREEN  */}
            {
              (loadingReducer.length > 0) ?
                <Loader isLoading={loadingReducer[0][1]} /> : ""
            }
            <MessagingBase />
          </>
      }
    </>
  )
}
